import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { AdditionalServiceType, LocalService, RelationShipRole } from 'src/service/local.service';

@Component({
  selector: 'app-activate-service',
  templateUrl: './activate-service.component.html',
  styleUrls: ['./activate-service.component.scss']
})
export class ActivateServiceComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["addtional_service"];
  @Input() additionalServiceType: AdditionalServiceType = AdditionalServiceType.None;
  @Input() businessId = ''; @Input() ctryCode = ''; @Input() userId = '';
  @Output() onActivated = new EventEmitter();
  RelationShipRole = RelationShipRole;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  onAction(index) {
    switch (index) {
      case 1: {
        if (this.businessId != '' && this.additionalServiceType != AdditionalServiceType.None) {
          this.configurationManagementService.activateAdditionalService(this.businessId, this.additionalServiceType, true).subscribe(result => {
            this.onActivated.emit();
          });
        }
      } break;
      case 2: {
        this.router.navigate(['/plan-purchase', this.ctryCode, this.userId, 2, this.businessId, 2]);
      } break;
    }
  }
}
